import { Component } from '@angular/core';
import { ApiServiceService } from '../../services/api-service.service';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment.development';
import { ToastrService } from 'ngx-toastr';
import { ChangeDetectorRef } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-rating',
  templateUrl: './rating.component.html',
  styleUrl: './rating.component.scss'
})
export class RatingComponent {

  // url: any;
  // format: any;
  // image : any;
  maxStars: number = 5;
  rating: any = 0;
  reviews: any = [];
  stars: { color: string }[] = [];
    img1 : any =[];
    selectedImage : any;
    productId : any;
  productDetails: any;
  productImages: any;
  userReview: any;

  ratingImageUrl = environment.ImageBaseUrl;
constructor( 
  private api:ApiServiceService,
  private activatedRoute :ActivatedRoute,
  private toastr: ToastrService, 
  private location: Location, 
  private cdref: ChangeDetectorRef
){
  this.initStars()
}
 

ngAfterViewInit(){
  this.activatedRoute.params.subscribe((product: any)=>{
    this.productId = product['id']
  })
  this.getProductByIds();
   
  }
  

getProductByIds(){
  this.api.getProductById(this.productId).subscribe(( data: any)=>{
    this.productDetails = data.data;
    this.cdref.detectChanges();
  })
}

initStars() {
  this.stars = [];
  for (let i = 1; i <= this.maxStars; i++) {
    this.stars.push({ color: i <= this.rating ? 'warning' : 'medium' });
  }
}

rate(starIndex: number) {
  this.rating = starIndex + 1;
  this.initStars();
}

cancel(){
  this.location.back();
}
submitReview(){
  const formData = new FormData()
  const userId = JSON.parse(localStorage.getItem("userId") as any);
  const rating = this.rating
  formData.append('product', this.productId),
  formData.append('user', userId),
  formData.append('reviewText', this.userReview),
  formData.append('rating', this.rating)

  this.img1.forEach((imageObj: any) => {
    formData.append('images', imageObj.file, `photo_${new Date().getTime()}.png`); 
  });
  this.api.AddRatingReview(formData).subscribe((res: any)=>{
      this.toastr.success(res.message);
  },((error: any)=>{
    this.toastr.error(error.error.message);
  }))
  
}



selectImage(item: any,i: any){
  this.selectedImage = item.image;
  this.img1.forEach((data : any, index : any)=>{
    if(i === index){
      data.isSelected = true;
    }else{
      data.isSelected = false;

    }
  })

 }




 deleteItem(item: any, index: any) {
  // Remove the image at the specified index from the question's images array
  if (index >= 0 && index < item.image?.length) {
    this.img1.splice(index, 1);
  }
}
  

fileChoose(event: any) {
  if (event.target.files && event.target.files.length > 0) {
    let fileList: FileList = event.target.files;

    for (let i = 0; i < fileList.length; i++) {
      let file: File = fileList[i];
      let reader = new FileReader();

      reader.onload = (e: any) => {
        this.img1.push({
          image: e.target.result,  // Base64 string (for preview)
          file: file,              // Actual file (for FormData)
          isSelected: false
        });
      };

      reader.readAsDataURL(file); // Convert to Base64 for preview
    }
  }
}

  }

